import * as components from "../../../includes/Components/components";
import {FormManager} from "../../../styleguide/js/components/form/form-manager";
import {NotificationComponent} from "../../../styleguide/js/components/notification/notification";
import {headerComponent} from "./components/headerComponent";
import {VideoComponent} from "./components/VideoComponent";
import {AjaxComponent} from "./ajax/ajaxComponent";



// WEBPACK FOOTER //
// ./web/app/themes/wwp_child_theme/assets/raw/js/app_styleguide.js